import React from 'react';
import { Outlet } from 'react-router-dom';
import './Layout.css';

// לוגואים
import logoHapoel from "../../assets/Logo/Logo_Hapoel.png";
import venusBanner from "../../assets/Logo/Venus_Banner.jpg";

const Layout = () => {
  return (
    <div className="layout">
      <header className="header">
        <img src={logoHapoel} alt="לוגו הפועל" className="logo" />
        <a href="/">
          <img src={venusBanner} alt="לוגו הליגה" className="logo_Banner" />        
        </a>
      </header>

      <main>
        <Outlet /> {/* כאן תופיע כל קומפוננטת דף */}
      </main>

      <footer className="footer">
        ונוסנט | כל הזכויות שמורות {new Date().getFullYear()} ©
        <div className="social-media">
          <a href="https://www.facebook.com/wnsh.prz.2025/" target="_blank" rel="noopener noreferrer" title='עמוד הפייסבוק של ונסה'>
            <i className="fab fa-facebook" />
          </a>
          <a href="https://www.instagram.com/vanessa_perets/" target="_blank" rel="noopener noreferrer" title='עמוד האינסטגרם של ונסה'>
            <i className="fab fa-instagram" />
          </a>
          <a href="/contact" target="_self" title='צרי קשר' rel="noopener noreferrer">
            <i className="fa-solid fa-envelope" />
          </a>
        </div>
        <br />
        <div className='credit'>
          Developed by
            <a
              href="https://www.linkedin.com/in/malek-butto/"
              target="_blank"
              rel="noopener noreferrer"
              title="Malek Butto"
              className="linkedin-link"
            >
              <span className="mb-icon">MB</span>
            </a>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
